import { render, staticRenderFns } from "./VLegals.vue?vue&type=template&id=f978b020&"
import script from "./VLegals.vue?vue&type=script&lang=js&"
export * from "./VLegals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports